import { render } from "./UserTraining.vue?vue&type=template&id=a152cfe4&scoped=true"
import script from "./UserTraining.vue?vue&type=script&lang=js"
export * from "./UserTraining.vue?vue&type=script&lang=js"

import "./UserTraining.vue?vue&type=style&index=0&id=a152cfe4&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a152cfe4"]])

export default __exports__